export default __webpack_public_path__ + "static/media/2_.470855c1.jpg";